import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { NzDrawerOptions } from 'ng-zorro-antd/drawer';
import { ModalOptions } from 'ng-zorro-antd/modal';

export interface AlainSTConfig {
  /**
   * èµ·å§é¡µç ï¼é»è®¤ä¸ºï¼`1`
   */
  pi?: number;
  /**
   * æ¯é¡µæ°éï¼å½è®¾ç½®ä¸º `0` è¡¨ç¤ºä¸åé¡µï¼é»è®¤ï¼`10`
   */
  ps?: number;
  /**
   * æ¯å¦æ¾ç¤ºè¾¹æ¡ï¼é»è®¤ï¼`false`
   */
  bordered?: boolean;
  /**
   * tableå¤§å°ï¼é»è®¤ï¼`default`
   */
  size?: 'small' | 'middle' | 'default';
  /**
   * æ¯å¦å¼å¯ååºå¼ï¼é»è®¤ï¼`true`
   */
  responsive?: boolean;
  /**
   * æ¯å¦å¨å°å±å¹ä¸ææ¾ç¤ºé¡¶é¨ä¸åºé¨ï¼é»è®¤ï¼`false`
   */
  responsiveHideHeaderFooter?: boolean;
  /** è¯·æ±ä½éç½® */
  req?: {
    /**
     * åé¡µç±»åï¼é»è®¤ï¼`page`
     * - `page` ä½¿ç¨ `pi`ï¼`ps` ç»å
     * - `skip` ä½¿ç¨ `skip`ï¼`limit` ç»å
     */
    type?: 'page' | 'skip';
    /** è¯·æ±æ¹æ³ï¼é»è®¤ï¼`GET` */
    method?: string;
    /** è¯·æ±ä½ `Header` */
    headers?: NzSafeAny;
    /**
     * éå½ååæ° `pi`ã`ps`ï¼é»è®¤ï¼`{ pi: 'pi', ps: 'ps', skip: 'skip', limit: 'limit' }`
     * - `{ pi: 'Page' }` => `pi` ä¼è¢«æ¿æ¢æ Page
     */
    reName?: {
      pi?: string;
      ps?: string;
      skip?: string;
      limit?: string;
    };
    /**
     * æ¯å¦å°è¯·æ±ææåæ°æ°æ®é½æ¾å¥ `body` å½ä¸­ï¼`url` å°åæ¬èº«åæ°é¤å¤ï¼ï¼ä»å½ `method: 'POST'` æ¶ææï¼é»è®¤ï¼`false`
     */
    allInBody?: boolean;
    /**
     * æ¯å¦å»¶è¿å è½½æ°æ®ï¼å³æ¸²æç»æåä¸ä¼ä¸»å¨åèµ·è¯·æ±ï¼é»è®¤ï¼`false`
     */
    lazyLoad?: boolean;
    /**
     * è¯·æ±åæ°æ®å¤ç
     */
    process?: (requestOptions: NzSafeAny) => NzSafeAny;
  };
  /** è¿åä½éç½® */
  res?: {
    /**
     * éå½åè¿ååæ° `total`ã`list`ï¼é»è®¤ï¼`{ list: ['list'], total: ['total'] }`
     * - `{ total: 'Total' }` => Total ä¼è¢«å½ä½ `total`
     */
    reName?: {
      total?: string | string[];
      list?: string | string[];
    };
    /**
     * æ°æ®é¢å¤ç
     */
    process?: (data: NzSafeAny[], rawData?: NzSafeAny) => NzSafeAny[];
  };
  /** è¿åä½éç½® */
  page?: {
    /**
     * åç«¯åé¡µï¼å½ `data` ä¸º`any[]` æ `Observable<any[]>` ææï¼é»è®¤ï¼`true`
     * - `true` ç± `st` æ ¹æ® `data` é¿åº¦åæ§åé¡µï¼åæ¬ï¼æåºãè¿æ»¤ç­
     * - `false` ç±ç¨æ·éè¿ `total` å `data` åæ°åæ§åé¡µï¼å¹¶ç»´æ¤ `(change)` å½åé¡µåæ´æ¶éæ°å è½½æ°æ®
     */
    front?: boolean;
    /**
     * åç«¯åé¡µæ¯å¦éç¨`0`åºç´¢å¼ï¼åªå¨`data`ç±»åä¸º`string`æ¶ææï¼é»è®¤ï¼`false`
     */
    zeroIndexed?: boolean;
    /**
     * æå®åé¡µæ¾ç¤ºçä½ç½®ï¼é»è®¤ï¼`bottom`
     */
    position?: 'top' | 'bottom' | 'both';
    /**
     * æå®åé¡µåé¡µæ¹åï¼é»è®¤ï¼`right`
     */
    placement?: 'left' | 'center' | 'right';
    /**
     * æ¯å¦æ¾ç¤ºåé¡µå¨ï¼é»è®¤ï¼`true`
     */
    show?: boolean;
    /**
     * æ¯å¦æ¾ç¤ºåé¡µå¨ä¸­æ¹åé¡µæ°ï¼é»è®¤ï¼`false`
     */
    showSize?: boolean;
    /**
     * åé¡µå¨ä¸­æ¯é¡µæ¾ç¤ºæ¡ç®æ°ä¸ææ¡å¼ï¼é»è®¤ï¼`[10, 20, 30, 40, 50]`
     */
    pageSizes?: number[];
    /**
     * æ¯å¦æ¾ç¤ºåé¡µå¨ä¸­å¿«éè·³è½¬ï¼é»è®¤ï¼`false`
     */
    showQuickJumper?: boolean;
    /**
     * æ¯å¦æ¾ç¤ºæ»æ°æ®éï¼é»è®¤ï¼`true`
     * - `boolean` ç±»åæ¾ç¤ºä¸å¦ï¼é»è®¤æ¨¡æ¿ï¼`å± {{total}} æ¡`
     * - `string` èªå®ä¹æ¨¡æ¿ï¼æ¨¡æ¿åéï¼
     *  - `{{total}}` è¡¨ç¤ºæ°æ®æ»é
     *  - `{{range[0]}}` è¡¨ç¤ºå½åé¡µå¼å§æ°éå¼
     *  - `{{range[1]}}` è¡¨ç¤ºå½åé¡µç»ææ°éå¼
     */
    total?: string | boolean;
    /**
     * åæ¢åé¡µæ¶è¿åé¡¶é¨ï¼é»è®¤ï¼`true`
     */
    toTop?: boolean;
    /**
     * è¿åé¡¶é¨åç§»å¼ï¼é»è®¤ï¼`100`
     */
    toTopOffset?: number;
  };
  /**
   * éå½åæåºå¼ï¼`columns` çéå½åé«äºå±æ§
   */
  sortReName?: { ascend?: string; descend?: string };
  /**
   * åæåºè§å
   * - è¥ä¸æå®ï¼åè¿åï¼`columnName=ascend|descend`
   * - è¥æå®ï¼åè¿åï¼`sort=columnName.(ascend|descend)`
   */
  singleSort?: {
    /** è¯·æ±åæ°åï¼é»è®¤ï¼`sort` */
    key?: string;
    /** ååä¸ç¶æé´åéç¬¦ï¼é»è®¤ï¼`.` */
    nameSeparator?: string;
  };
  /**
   * æ¯å¦å¤æåºï¼å½ `sort` å¤ä¸ªç¸åå¼æ¶èªå¨åå¹¶ï¼å»ºè®®åç«¯æ¯ææ¶ä½¿ç¨
   */
  multiSort?: {
    /** è¯·æ±åæ°åï¼é»è®¤ï¼`sort` */
    key?: string;
    /** ä¸åå±æ§é´åéç¬¦ï¼é»è®¤ï¼`-` */
    separator?: string;
    /** ååä¸ç¶æé´åéç¬¦ï¼é»è®¤ï¼`.` */
    nameSeparator?: string;
    /**
     * æ¯å¦å¨å±å¤æåºæ¨¡å¼ï¼é»è®¤ï¼`true`
     * - `true` è¡¨ç¤ºææ `st` é»è®¤ä¸ºå¤æåº
     * - `false` è¡¨ç¤ºéè¦ä¸ºæ¯ä¸ª `st` æ·»å  `multiSort` æä¼è§ä¸ºå¤æåºæ¨¡å¼
     */
    global?: boolean;
    /**
     * æ¯å¦ä¿æç©ºå¼çé®åï¼é»è®¤ï¼`true`
     * - `true` è¡¨ç¤ºä¸ç®¡æ¯å¦ææåºé½ä¼åé `key` é®å
     * - `false` è¡¨ç¤ºæ æåºå¨ä½æ¶ä¸ä¼åé `key` é®å
     */
    keepEmptyKey?: boolean;
  };
  /**
   * æé®æ¨¡ææ¡éç½®
   */
  modal?: {
    /**
     * æå®æ¨¡ææ¡ç®æ ç»ä»¶çæ¥æ¶åæ°åï¼é»è®¤ï¼`record`
     */
    paramsName?: string;
    /** å¤§å°ï¼ä¾å¦ï¼lgã600ï¼é»è®¤ï¼`lg` */
    size?: 'sm' | 'md' | 'lg' | 'xl' | '' | number;
    /** å¯¹è¯æ¡ [ModalOptions](https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/components/modal/modal-types.ts) åæ° */
    modalOptions?: ModalOptions;
    /** æ¯å¦ç²¾åï¼é»è®¤ï¼`true`ï¼ï¼è¥è¿åå¼éç©ºå¼ï¼`null`æ`undefined`ï¼è§ä¸ºæåï¼å¦åè§ä¸ºéè¯¯ */
    exact?: boolean;
  };
  /**
   * æé®æ½å±éç½®
   */
  drawer?: {
    /**
     * æ½å±ç®æ ç»ä»¶çæ¥æ¶åæ°åï¼é»è®¤ï¼`record`
     */
    paramsName?: string;
    /**
     * å¤§å°ï¼ä¾å¦ï¼lgã600ï¼é»è®¤ï¼`md`
     *
     * | ç±»å | é»è®¤å¤§å° |
     * | --- | ------ |
     * | `sm` | `300` |
     * | `md` | `600` |
     * | `lg` | `900` |
     * | `xl` | `1200` |
     *
     * > ä»¥ä¸å¼ï¼å¯éè¿è¦çç¸åºçLESSåæ°èªè¡è°æ´
     */
    size?: 'sm' | 'md' | 'lg' | 'xl' | number;
    /**
     * æ¯å¦åå«åºé¨å·¥å·æ¡ï¼é»è®¤ï¼`true`
     */
    footer?: boolean;
    /**
     * åºé¨å·¥å·æ¡é«åº¦ï¼é»è®¤ï¼`55`
     */
    footerHeight?: number;
    /** æ½å± [NzDrawerOptions](https://ng.ant.design/components/drawer/zh#nzdraweroptions) åæ° */
    drawerOptions?: NzDrawerOptions;
  };
  /**
   * æ°æ³¡åæ°
   */
  pop?: {
    /**
     * Title of the popover, default: `ç¡®è®¤å é¤åï¼`
     */
    title?: string;

    /**
     * Popover trigger mode, default: `click`
     */
    trigger?: 'click' | 'focus' | 'hover';

    /**
     * The position of the popover relative to the target, default: `top`
     */
    placement?:
      | 'top'
      | 'left'
      | 'right'
      | 'bottom'
      | 'topLeft'
      | 'topRight'
      | 'bottomLeft'
      | 'bottomRight'
      | 'leftTop'
      | 'leftBottom'
      | 'rightTop'
      | 'rightBottom';

    /**
     * Class name of the popover card
     */
    overlayClassName?: string;

    /**
     * Style of the popover card
     */
    overlayStyle?: {};

    /**
     * Text of the Cancel button
     */
    cancelText?: string;

    /**
     * Text of the Confirm button
     */
    okText?: string;

    /**
     * Button `type` of the Confirm button
     */
    okType?: 'primary' | 'ghost' | 'dashed' | 'danger' | 'default';

    /**
     * Customize icon of confirmation
     */
    icon?: string;
  };
  /**
   * è¡åå»å¤å°æ¶é¿ä¹ç±»ä¸ºåå»ï¼åä½ï¼æ¯«ç§ï¼ï¼é»è®¤ï¼`200`
   */
  rowClickTime?: number;
  /**
   * è¿æ»¤æé®ç¡®è®¤ææ¬
   */
  filterConfirmText?: string;
  /**
   * è¿æ»¤æé®éç½®ææ¬
   */
  filterClearText?: string;
  /**
   * æé®å¾æ 
   */
  btnIcon?: {
    /** å¾æ ç±»å */
    type: string;
    /** å¾æ ä¸»é¢é£æ ¼ï¼é»è®¤ï¼`outline` */
    theme?: 'outline' | 'twotone' | 'fill';
    /** æ¯å¦ææè½¬å¨ç»ï¼é»è®¤ï¼`false` */
    spin?: boolean;
    /** ä»éç¨åè²å¾æ ï¼è®¾ç½®åè²å¾æ çä¸»è¦é¢è²ï¼ä»å¯¹å½å icon çæ */
    twoToneColor?: string;
    /** æå®æ¥èª IconFont çå¾æ ç±»å */
    iconfont?: string;
  };
  /**
   * è¡å·ç´¢å¼ï¼é»è®¤ï¼`1`
   * - è®¡ç®è§åä¸ºï¼`index + noIndex`
   */
  noIndex?: number;
  /**
   * è¡¨æ ¼è¡çç±»å
   */
  rowClassName?: (record: NzSafeAny, index: number) => string;
  /**
   * éè¿ç¹å»è¡æ¥å±å¼å­è¡ï¼Default: `false`
   */
  expandRowByClick?: boolean;
  /**
   * æé£ç´æ¨¡å¼ï¼Default: `false`
   */
  expandAccordion?: boolean;
  /**
   * æå® `width` æ¨¡å¼
   */
  widthMode?: {
    /**
     * å®½åº¦ç±»åï¼é»è®¤ï¼`default`
     * - `default` é»è®¤è¡ä¸º
     * - `strict` ä¸¥æ ¼æ¨¡å¼ï¼å³å¼ºå¶æ `width` æå®çå®½åº¦åç°ï¼å¹¶æ ¹æ® `strictBehavior` ç±»åå¤ç
     */
    type?: 'strict' | 'default';
    /**
     * ä¸¥æ ¼æ¨¡å¼çå¤çè¡ä¸ºï¼é»è®¤ï¼`truncate`
     * - `wrap` å¼ºå¶æ¢è¡
     * - `truncate` æªç­
     */
    strictBehavior?: 'wrap' | 'truncate';
  };
  /**
   * Default: `54`
   */
  virtualItemSize?: number;
  /**
   * Default: `200`
   */
  virtualMaxBufferPx?: number;
  /**
   * Default: `100`
   */
  virtualMinBufferPx?: number;

  /**
   * Conditional expression rendering behavior, can be set to `hide` (default) or `disabled`, Default: `hide`
   */
  iifBehavior?: 'hide' | 'disabled';
}
